import usePathParams from "../use-path-params";
import { useQueryParamValue } from "../use-query-param";
import { ReactElement, useState } from "react";
import useClusterPriceCalculator from "./use-cluster-price-calculator";
import { CouponSourceContext } from "../use-price-calculator/CouponSourceContext";
import React from "react";

interface ClusterPriceCalculatorContextProps {
  path: string;
  id: string;
  clusterSlugKey: string;
  checkinDateKey: string;
  checkoutDateKey: string;
  adultCountKey: string;
  childCountKey: string;
  couponCodeKey: string;
  offeringTypeIdsKey: string;
  children: ReactElement;
}

function ClusterPriceCalculatorContext(props: ClusterPriceCalculatorContextProps) {
  const {
      path,
      id,
      clusterSlugKey,
      checkinDateKey,
      checkoutDateKey,
      adultCountKey,
      childCountKey,
      couponCodeKey,
      offeringTypeIdsKey,
      children,
    } = props,
    cluster_slug = usePathParams(path, clusterSlugKey),
    checkin_date = useQueryParamValue("date", checkinDateKey),
    checkout_date = useQueryParamValue("date", checkoutDateKey),
    adult_count = useQueryParamValue("integer", adultCountKey),
    child_count = useQueryParamValue("integer", childCountKey),
    coupon_code = useQueryParamValue("string", couponCodeKey),
    offering_type_ids = useQueryParamValue("string", offeringTypeIdsKey);
    // { configArgs } = usePropertyConfigValues(property_slug, configs);
    const [couponSource, setCouponSource] = useState<"backend" | "manual" | "list" | null>(null);

    // // Memoize the config args to prevent unnecessary recalculations
    // const memoizedConfigArgs = useMemo(() => configArgs, [
    //   JSON.stringify(configArgs),
    // ]);

  useClusterPriceCalculator(
    id,
    cluster_slug,
    checkin_date,
    checkout_date,
    adult_count,
    child_count,
    coupon_code,
    couponSource,  
    offering_type_ids, 
  );

  return (
    <CouponSourceContext.Provider value={{ couponSource, setCouponSource }}>
      {children}
    </CouponSourceContext.Provider>
  );
}

export default ClusterPriceCalculatorContext;